module.exports = "/images/Icon industry-GoKart.svg?9548d7533246cad56e7a21a986deaa42";